// App-wide live input character filtering. Self-initializes on import (same
// pattern as tooltip.js / modalBackdrop.js): ONE delegated document listener,
// so dynamically injected forms (staff invite, loyalty modals, auth panels)
// are covered automatically. Disallowed characters are stripped as they're
// typed or pasted, with the caret kept where the user expects it.
//
// What gets filtered:
// - input[type="tel"]   -> digits only. EXCEPT inputs inside an intl-tel-input
//   wrapper (.iti) - that widget formats with +, spaces and dashes itself
//   (business phone in Settings, onboarding phone).
// - input[type="email"] -> the practical email charset (letters, digits,
//   @ . _ % + -).
// - Person-name fields (known ids below, or any input with
//   data-filter="name") -> letters in any language plus spaces, hyphens,
//   apostrophes, and periods. Deliberately NOT applied to business/item/role
//   names - those legitimately contain digits ("7-Eleven", "Size 12").
import { stripNonDigits, stripNonNameChars, stripNonEmailChars } from "./loyalty.js";

const NAME_FIELD_IDS = new Set([
  "settingsProfileFirstName", "settingsProfileLastName", // Settings > My Profile
  "signUpFirstName", "signUpLastName",                   // owner sign-up form
  "inviteFirstName", "inviteLastName",                   // staff invite modal
]);

const _stripFor = function (el) {
  if (el.dataset?.filter === "name" || NAME_FIELD_IDS.has(el.id)) return stripNonNameChars;
  if (el.type === "tel" && !el.closest(".iti")) return stripNonDigits;
  if (el.type === "email") return stripNonEmailChars;
  return null;
};

document.addEventListener("input", (e) => {
  const el = e.target;
  if (!(el instanceof HTMLInputElement)) return;
  const strip = _stripFor(el);
  if (!strip) return;
  const clean = strip(el.value);
  if (clean === el.value) return;
  // Caret position = how many kept characters precede it (selectionStart is
  // null on some input types - fall back to end-of-value).
  const caretKept = strip(
    el.value.slice(0, el.selectionStart ?? el.value.length),
  ).length;
  el.value = clean;
  try { el.setSelectionRange(caretKept, caretKept); } catch {} // unsupported on some types
});
